import {Component, input} from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {Button} from 'primeng/button';

@Component({
  selector: 'ng-alert-dialog',
  imports: [
    Button
  ],
  template: `
    <div style="margin-bottom: 20px; display: flex; gap: 20px">
      <div style="font-size: 2rem;color:var(--p-button-danger-background)">
        <i class="fa-regular fa-circle-exclamation"></i>
      </div>
      <div>
        {{ message() }}
      </div>
    </div>
    <div style="display: flex; gap: 1rem;justify-content: flex-end;">
      <p-button severity="secondary" label="OK" (onClick)="cancel()"></p-button>
    </div>
  `
})
export class AlertDialog {
  public message = input("")

  constructor(private ref: DynamicDialogRef,) {
  }

  cancel() {
    this.ref.close(false);
  }
}
